import { Box, DialogContent, DialogTitle } from '@mui/material';
import colors from 'assets/theme/base/colors';
import * as React from 'react';
import rgba from 'assets/theme/function/rgba';
import DialogIconClose from 'component/dialog-icon-close';
import ProductDetail from 'pages/product/product-detail-page';

interface Props {
    setOpenViewProductDialog: React.Dispatch<React.SetStateAction<boolean>>;
    viewProduct: string;
}

const ViewProduct: React.FC<Props> = ({
    setOpenViewProductDialog,
    viewProduct,
}) => {
    const closeModal = () => {
        setOpenViewProductDialog(false);
    };

    return (
        <>
            <Box
                display={'flex'}
                justifyContent={'center'}
                bgcolor={rgba(colors.primary.main, 0.5)}
            >
                <DialogTitle textTransform={'uppercase'}>
                    VIEW PRODUCT
                </DialogTitle>
                <DialogIconClose handleClose={closeModal} />
            </Box>

            <DialogContent>
                <ProductDetail viewProduct={viewProduct} />
            </DialogContent>
        </>
    );
};
export default ViewProduct;
